export default __webpack_public_path__ + "static/media/partner15.00595ae6.png";